import { ProgramCardShimmer } from "src/components/program/conductor/program.cad.shimmer";
import { DateService } from "src/services";

export const ArchiveListShimmer: React.FC = () => {

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    return (
        <div className="archive-list-area">
            <div className="clearfix d-flex justify-content-between align-items-end text-rtl dates-row">
                <div className="float-right text-rtl text-right program-list-date mt-4 date-start">
                    {DateService.persianDate(yesterday, "dddd")}
                </div>
                <div className="float-left text-rtl text-left program-list-date mt-4 date-end">
                    {DateService.persianDate(yesterday, "YYYY/M/D")}
                </div>
            </div>
            <div className="col-12 p-0">
                {
                    [...new Array(10)].map((x, index) => (<ProgramCardShimmer key={index} />))
                }
            </div>
        </div>
    );
};